const staffRoleOptions = [
  { value: 'SALES_MANAGER', label: 'Sales manager' },
  { value: 'SALES_PERSON', label: 'Sales person' },
  { value: 'FNI_MANAGER', label: 'F&I Manager' },
  { value: 'BDC', label: 'Business Development Center' },
  { value: 'ADMIN', label: 'Admin' }
];

export default staffRoleOptions;
